import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
/**
 * Where a member of the club goes to end the membership, when the club has
 * set a link in Crystallize. A path or a URL.
 */
export const getBookClubCancelHref = (subscription) => getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.CANCEL_LINK)?.text?.trim() || undefined;
